import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { AxiosResponse } from "axios";
import { OkHnRow } from "./models-service";
import { exportToExcelFile } from "@/utils/excel";

export const route_ns = `losses`;

class LossesInputService {
  public crud = base_ds.getBaseCrud(route_ns);

  public async getWithFilter(id_cut: string, id_facility: number, periods: string): Promise<OkHnRow[]> {
    const url = `${route_ns}?filter=[["id_cut","=","${id_cut}"],"and",["id_eco_facility","=","${id_facility}"],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async getChanged(id_cut: string, id_facility: number, blocks: string[], periods: string): Promise<OkHnRow[]> {
    const url = `${route_ns}?filter=[["id_cut","=","${id_cut}"],"and",["id_eco_facility","=","${id_facility}"],"and",["block","in",${JSON.stringify(blocks)}],"and",["month","in",${JSON.stringify(periods)}]]`
    const response: AxiosResponse["data"] = await request({
      url: url,
      method: "get",
    });
    let result = [];
    if(response && response.data) {
      result = response.data;
    }
    return result;
  }

  public async exportToExcel(data: any, filename: string | null = null) {
    await exportToExcelFile(data, route_ns, filename);
  }

  public async save(pack: OkHnRow[]) {
    return await request({
      url: route_ns,
      method: "post",
      data: {data: pack},
    });
  }

  public async savePack(pack: OkHnRow[]) {
    try {
      pack.forEach(row => {
        this.crud.save(row);
      });
    } catch (err) {
      console.log(err);
    }
  }
}

export default new LossesInputService();
